import {InjectionToken} from "@angular/core";

export interface User {
  id: number;
  role: "global" | string;
  name: string;
  email: string;
  companiesIds: Array<string>;
  company?: any | null;
  defaultLanguage: string;
  urlAvatar: string;
}


export interface UserService {
  getCurrentUser(): User;
  isCurrentUserManager(): boolean;
  isCurrentUserGlobal(): boolean;
}

export const USER_SERVICE = new InjectionToken<UserService>('User service for libs');
